import CandidateDetail from './pages/CandidateDetail';
import ClientDetail from './pages/ClientDetail';
import JobDetail from './pages/JobDetail';
import DeploymentDetail from './pages/DeploymentDetail';
import CandidateRegister from './pages/CandidateRegister';
import CandidateLogin    from './pages/CandidateLogin';
import CandidatePortal   from './pages/CandidatePortal';
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import Candidates from './pages/Candidates';
import Jobs from './pages/Jobs';
import Deployments from './pages/Deployments';
import Attendance from './pages/Attendance';
import SalaryComponents from './pages/SalaryComponents';
import LeaveSetup from './pages/LeaveSetup';
import AttendanceRegister from './pages/AttendanceRegister';
import StatutoryCompliance from './pages/StatutoryCompliance';
import Reimbursements from './pages/Reimbursements';
import PayrollRegister from './pages/PayrollRegister';
import AnnualPayroll from './pages/AnnualPayroll';
import Payroll from './pages/Payroll';
import Invoices from './pages/Invoices';
import Reports from './pages/Reports';
import Users from './pages/Users';
import Backup from './pages/Backup';

const queryClient = new QueryClient();

// Protected route wrapper
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center text-gray-400">
      Loading...
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  // Redirect candidates to their portal
  if (user.role === 'candidate') return <Navigate to="/candidate/portal" replace />;
  return <Layout>{children}</Layout>;
};

const AppRoutes = () => {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={
  user
    ? user.role === 'candidate'
      ? <Navigate to="/candidate/portal" replace />
      : <Navigate to="/dashboard" replace />
    : <Login />
} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/clients" element={<ProtectedRoute><Clients /></ProtectedRoute>} />
      <Route path="/clients/:id" element={<ProtectedRoute><ClientDetail /></ProtectedRoute>} />
      <Route path="/candidates" element={<ProtectedRoute><Candidates /></ProtectedRoute>} />
      <Route path="/jobs" element={<ProtectedRoute><Jobs /></ProtectedRoute>} />
      <Route path="/jobs/:id" element={<ProtectedRoute><JobDetail /></ProtectedRoute>} />
      <Route path="/deployments" element={<ProtectedRoute><Deployments /></ProtectedRoute>} />
      <Route path="/deployments/:id" element={<ProtectedRoute><DeploymentDetail /></ProtectedRoute>} />
      <Route path="/attendance" element={<ProtectedRoute><Attendance /></ProtectedRoute>} />
      <Route path="/salary-components" element={<ProtectedRoute><SalaryComponents /></ProtectedRoute>} />
      <Route path="/leave-setup"            element={<ProtectedRoute><LeaveSetup /></ProtectedRoute>} />
      <Route path="/attendance-register"    element={<ProtectedRoute><AttendanceRegister /></ProtectedRoute>} />
      <Route path="/statutory-compliance" element={<ProtectedRoute><StatutoryCompliance /></ProtectedRoute>} />
      <Route path="/reimbursements" element={<ProtectedRoute><Reimbursements /></ProtectedRoute>} />
      <Route path="/payroll-register" element={<ProtectedRoute><PayrollRegister /></ProtectedRoute>} />
      <Route path="/annual-payroll"   element={<ProtectedRoute><AnnualPayroll /></ProtectedRoute>} />
      <Route path="/payroll" element={<ProtectedRoute><Payroll /></ProtectedRoute>} />
      <Route path="/invoices" element={<ProtectedRoute><Invoices /></ProtectedRoute>} />
      <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
      <Route path="/users" element={<ProtectedRoute><Users /></ProtectedRoute>} />
      <Route path="/backup" element={<ProtectedRoute><Backup /></ProtectedRoute>} />
      <Route path="/candidate/register" element={<CandidateRegister />} />
      <Route path="/candidate/login"    element={<CandidateLogin />} />
      <Route path="/candidate/portal"   element={<CandidatePortal />} />
      <Route path="/candidates/:id" element={<ProtectedRoute><CandidateDetail /></ProtectedRoute>} />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;